<template>
    <div class="p-admin-conf-mail">
        <div class="card mb-3">
            <div class="card-header">メール上段設定<span class="small">（{{ $locale.patient }}へ送信されるメール内容）</span></div>
            <div class="card-body" v-if="configurations">
                <div
                    v-show="!isOpenMailEdit"
                    v-for="(conf, index) in configurations">
                    <div v-if="conf.value_type === confValue.text && conf.key !== 'mail_signature'" class="m-1">
                        <div
                            class="vc-row d-flex justify-content-between"
                            :class="{ 'vc-row--last' : index + 1 === configurations.length }">
                            <div class="vc-row__name">{{ conf.name }}</div>
                            <button
                                style="min-width: 70px;"
                                class="btn btn-sm btn-yokumiru-blue"
                                @click="openMailEdit(conf)"
                                :disabled="inProgress">
                                編集
                            </button>
                        </div>
                    </div>
                </div>
                <div v-show="isOpenMailEdit">
                    <admin-conf-mail-edit
                        :preview-base-url="`${this.appUrl}/admin/mail_previews`">
                    </admin-conf-mail-edit>
                </div>
            </div>
        </div>

        <div
            v-show="!isOpenMailEdit"
            class="card mb-3">
            <div class="card-header">メール署名欄設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <div v-if="conf.key === 'mail_signature'" class="m-1">
                        <div class="form-group m-form__group">
                            <textarea
                                v-model="configurations[index].value"
                                :id="`key-${conf.key}`"
                                class="form-control m-input m-input--air"
                                :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                rows="7">
                            </textarea>
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor,
    },

    props: {
        conf: {
            type: Array,
            required: true,
        },
        appUrl: {
            type: String,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            isOpenMailEdit: false,
            configurations: [],
            preview: null,
            errors: {},
            timer: null,
            inProgress: false,
            inProgressPreview: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline'],
                            [{ 'header': [1, 2, 3, 4, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link', 'divider'],
                        ],
                        // @see https://quilljs.com/docs/modules/toolbar/#handlers
                        handlers: {
                            divider: function() {
                                this.quill.format('divider', '-')
                            },
                        },
                    },
                },
                placeholder: 'ここに内容を入力してください',
            },
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },
    },

    created: function () {
        bus.$on('close-mail-edit', () => this.isOpenMailEdit = false)
    },

    beforeDestroy: function () {
        bus.$off('close-mail-edit')
    },

    methods: {
        /**
         * {object} conf
         */
        openMailEdit: function (conf) {
            this.isOpenMailEdit = true
            bus.$emit('open-mail-edit', conf)
        },

        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf
        },
    }
}
</script>

<style scoped lang="scss">
.vc-row {
    padding: 12px 0 7px;
    border-top: 1px solid #ddd;

    &.vc-row--last {
        padding-bottom: 11px;
        border-bottom: 1px solid #ddd;
    }

    .vc-row__name {
        line-height: 28px;
    }
}
</style>
